module.exports = __webpack_public_path__ + "img/success.feb57d61.png";